import { SxProps } from '@mui/material/styles';

import HookFormTextField from 'reservations/form/components/HookFormTextField';

type NameFormFieldProps = {
  sxOverride?: SxProps;
  labelSxOverride?: SxProps;
  errorColorOverride?: SxProps;
};

function NameFormField({
  sxOverride = {},
  labelSxOverride = {},
  errorColorOverride = {}
}: NameFormFieldProps) {
  return (
    <HookFormTextField
      name="name"
      label="Name"
      required
      sxOverride={sxOverride}
      labelSxOverride={labelSxOverride}
      errorColorOverride={errorColorOverride}
    />
  );
}

export default NameFormField;
